import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "@/views/home-view.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/not-found",
    name: "notFound",
    component: () => import("@/views/not-found-view.vue"),
  },
  {
    path: "*",
    redirect: {
      name: "notFound",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
